import { Turbo } from '@hotwired/turbo-rails'

Turbo.StreamActions.closeModal = function () {
  document.getElementById('block_modal')?.close()
}

Turbo.StreamActions.set_style = function () {
  const name = this.getAttribute('name')
  const value = this.getAttribute('value') || ''

  if (name) {
    this.targetElements.forEach((element) => {
      if (name.startsWith('--')) {
        element.style.setProperty(name, value)
      } else {
        element.style[name] = value
      }
    })
  } else {
    console.warn('[TurboStream] no "name" provided for action "set_style"')
  }
}
